import { JSX } from "react";

import ArrowBackIcon from "@mui/icons-material/KeyboardArrowLeft";
import ArrowForwardIcon from "@mui/icons-material/KeyboardArrowRight";
import { Grid, Typography, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useGridApiContext, useGridSelector, gridPageSelector, gridPageCountSelector } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

function CustomPagination(): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();
  const apiRef = useGridApiContext();
  const currentPage = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const handlePreviousPage = (): void => {
    if (currentPage > 0) {
      apiRef.current.setPage(currentPage - 1);
    }
  };

  const handleNextPage = (): void => {
    if (currentPage < pageCount - 1) {
      apiRef.current.setPage(currentPage + 1);
    }
  };

  return (
    <Grid display='flex' alignItems='center' justifyContent='center'>
      <Typography fontSize={theme.fontSizes.sm} fontWeight={theme.typography.fontWeightLight}>
        {t(`Page`)} {currentPage + 1} of {pageCount}
      </Typography>
      <IconButton onClick={handlePreviousPage} disabled={currentPage === 0} aria-label='Previous page'>
        <ArrowBackIcon />
      </IconButton>
      <IconButton onClick={handleNextPage} disabled={currentPage >= pageCount - 1} aria-label='Next page'>
        <ArrowForwardIcon />
      </IconButton>
    </Grid>
  );
}

export default CustomPagination;
